/* ==========================================================================
   Stivo — плъзгаща се количка.

   ЕДНО ПРАВИЛО ГИ ДЪРЖИ ВСИЧКИТЕ: разметката идва от Liquid.
   След всяко /cart/add.js и /cart/change.js дърпаме СЪЩАТА секция през
   Section Rendering API (?section_id=stivo-cart-drawer) и подменяме само
   вътрешността на [data-sdrw-body]. Тук няма нито един ред, който да сглобява
   цена, валута или превод — иначе рано или късно се разминава с Liquid.

   Обвивката (скримът и панелът) НЕ се пипа при обновяване, затова отвореното
   състояние и позицията на скрола преживяват добавянето на артикул.

   БЕЗ JAVASCRIPT: коренът е с атрибут hidden в Liquid и се отключва само тук.
   Иконата в хедъра си остава връзка към /cart, формите правят нормален POST
   към /cart/add и водят до страницата на количката. Нищо не увисва.

   Всички слушатели висят на document, не на панела. Причината е, че редакторът
   на теми пресъздава цялата секция при всяка промяна на настройка — слушател,
   закачен за стария корен, би замълчал тихо. bind() само пре-намира елементите.
   ========================================================================== */
(function () {
  'use strict';

  var SECTION = 'stivo-cart-drawer';
  if (!window.fetch || !window.DOMParser || !document.documentElement.closest) return;

  /* Ако файлът бъде изпълнен втори път (редактор на теми, чужд app), НЕ се
     закачат втори слушатели — второто изпълнение само пре-намира елементите
     през вече закачената логика. Иначе едно натискане би добавило два пъти. */
  if (window.StivoCartDrawer) {
    window.StivoCartDrawer();
    return;
  }

  var root = null;
  var panel = null;
  var body = null;
  var opener = null; /* елементът, отворил панела — фокусът се връща там */
  var busy = false;

  /* ---------- помощни ---------------------------------------------------- */

  /* Адресът за Section Rendering API. Взима се от текущата страница, за да
     работи и при втори език (/en) — там кореновият път не е „/". */
  function sectionUrl() {
    var base = window.location.pathname || '/';
    /* Служебните адреси на количката връщат пренасочване, не страница. */
    if (base.indexOf('/cart') === 0) base = '/';
    return base + '?section_id=' + encodeURIComponent(SECTION);
  }

  function say(msg) {
    var live = root && root.querySelector('[data-sdrw-live]');
    if (live) live.textContent = msg;
  }

  function isOpen() {
    return !!root && root.dataset.open === 'true';
  }

  function focusables() {
    if (!panel) return [];
    var list = panel.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.hasAttribute('hidden')) continue;
      if (el.offsetWidth === 0 && el.offsetHeight === 0) continue;
      out.push(el);
    }
    return out;
  }

  /* ---------- отваряне и затваряне -------------------------------------- */

  function open(from) {
    if (!root || isOpen()) return;
    opener = from || document.activeElement;
    root.dataset.open = 'true';
    document.body.classList.add('sdrw-lock');
    /* Фокусът влиза в САМИЯ панел, не върху бутона за затваряне. Панелът е
       tabindex="-1", значи не рисува пръстен, а следващият Tab пак влиза в
       съдържанието. Фокус върху ✕ при отваряне рисуваше дебел оранжев ринг
       около бутона и изглеждаше като дефект. */
    panel.focus();
  }

  function close() {
    if (!isOpen()) return;
    root.dataset.open = 'false';
    document.body.classList.remove('sdrw-lock');
    if (opener && document.contains(opener)) opener.focus();
    opener = null;
  }

  /* ---------- обновяване от Section Rendering API ------------------------ */

  function paintHeader() {
    var state = body && body.querySelector('[data-sdrw-state]');
    if (!state) return;
    var count = parseInt(state.getAttribute('data-count'), 10);
    if (isNaN(count)) count = 0;
    var total = state.getAttribute('data-total') || '';

    var badge = document.querySelector('.act--cart [data-stivo-cart-count]');
    if (badge) {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    }
    var sum = document.querySelector('.act--cart [data-stivo-cart-total]');
    if (sum && total) sum.textContent = total;
  }

  function refresh() {
    return fetch(sectionUrl(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('section ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sdrw-body]');
        if (!fresh || !body) throw new Error('no body');
        /* Пази позицията на скрола — иначе всяко „+" подскача най-горе. */
        var old = body.querySelector('[data-sdrw-scroll]');
        var top = old ? old.scrollTop : 0;
        body.innerHTML = fresh.innerHTML;
        var next = body.querySelector('[data-sdrw-scroll]');
        if (next && top) next.scrollTop = top;
        paintHeader();
      });
  }

  function lock(on) {
    busy = on;
    if (root) root.dataset.busy = on ? 'true' : 'false';
  }

  /* Мрежова грешка НЕ бива да остави количката в измислено състояние.
     Отиваме на /cart — сървърът е истината. */
  function fail() {
    lock(false);
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  function change(key, quantity) {
    if (busy) return;
    lock(true);
    say('Обновяваме количката…');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change ' + r.status);
        return refresh();
      })
      .then(function () {
        lock(false);
        say('Количката е обновена.');
      })
      .catch(fail);
  }

  function add(form, from) {
    if (busy) return;
    lock(true);
    say('Добавяме в количката…');
    /* Двете неуспехи не са едно и също: неуспешно ДОБАВЯНЕ може да се повтори
       със самата форма, а неуспешно ОБНОВЯВАНЕ след успешно добавяне не бива —
       второ изпращане би сложило артикула два пъти. */
    var added = false;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add ' + r.status);
        added = true;
        return refresh();
      })
      .then(function () {
        lock(false);
        say('Продуктът е добавен в количката.');
        /* Добавяне ОТВЪТРЕ не затваря и не отваря наново — панелът е вече тук
           и релсът просто се е пренаписал. */
        if (!isOpen()) open(from);
      })
      .catch(function () {
        if (added) {
          fail();
          return;
        }
        lock(false);
        /* Без AJAX формата пак работи по стария начин — към /cart. */
        form.submit();
      });
  }

  /* ---------- слушатели (веднъж, на document) ---------------------------- */

  /* Всяка форма за добавяне в страницата: продуктовата, картите в мрежите и
     клетките в релса. Формите остават валидни и без JavaScript. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!root || !form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    add(form, document.activeElement);
  });

  document.addEventListener('click', function (e) {
    if (!root || !e.target || !e.target.closest) return;

    /* Иконата на количката в хедъра отваря панела вместо да води към /cart. */
    var openBtn = e.target.closest('[data-stivo-cart-open]');
    if (openBtn) {
      e.preventDefault();
      open(openBtn);
      return;
    }

    if (e.target.closest('[data-sdrw-close]')) {
      e.preventDefault();
      close();
      return;
    }

    var step = e.target.closest('[data-sdrw-step]');
    if (step && root.contains(step)) {
      var line = step.closest('[data-sdrw-line]');
      var input = line && line.querySelector('[data-sdrw-qty]');
      if (!input) return;
      var next = (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-sdrw-step'), 10);
      if (next < 0) next = 0;
      input.value = String(next);
      change(step.getAttribute('data-key'), next);
      return;
    }

    var rm = e.target.closest('[data-sdrw-remove]');
    if (rm && root.contains(rm)) change(rm.getAttribute('data-key'), 0);
  });

  /* Ръчно въведено количество — пали се при напускане на полето. */
  document.addEventListener('change', function (e) {
    if (!root || !e.target || !e.target.closest) return;
    var input = e.target.closest('[data-sdrw-qty]');
    if (!input || !root.contains(input)) return;
    var q = parseInt(input.value, 10);
    if (isNaN(q) || q < 0) q = 0;
    change(input.getAttribute('data-key'), q);
  });

  document.addEventListener('keydown', function (e) {
    if (!root) return;

    if (e.key === 'Enter' && e.target && e.target.closest) {
      var input = e.target.closest('[data-sdrw-qty]');
      if (input && root.contains(input)) {
        e.preventDefault();
        input.blur();
        return;
      }
    }

    if (!isOpen()) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }

    /* Капан за фокуса: Tab не излиза от панела, докато е отворен. */
    if (e.key !== 'Tab') return;
    var items = focusables();
    if (!items.length) {
      e.preventDefault();
      panel.focus();
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (e.shiftKey && (active === first || !panel.contains(active))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* Фокус, отскочил извън панела (клик по фона, лента на браузъра). */
  document.addEventListener('focusin', function (e) {
    if (!isOpen() || panel.contains(e.target)) return;
    panel.focus();
  });

  /* ---------- начално и повторно свързване ------------------------------- */

  function bind() {
    root = document.querySelector('[data-sdrw]');
    panel = root ? root.querySelector('[data-sdrw-panel]') : null;
    body = root ? root.querySelector('[data-sdrw-body]') : null;
    if (!root || !panel || !body) {
      root = null;
      panel = null;
      body = null;
      return;
    }
    /* Отключване: чак сега панелът съществува за окото. */
    root.hidden = false;
    paintHeader();
  }

  window.StivoCartDrawer = bind;
  bind();

  /* Редакторът на теми пресъздава секцията при всяка промяна на настройка. */
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.detail || e.detail.sectionId !== SECTION) return;
    busy = false;
    opener = null;
    document.body.classList.remove('sdrw-lock');
    bind();
  });
})();
